import * as Yup from 'yup'

const phoneRegExp = /^((\+[1-9]{2,4})|0)([0-9]{8,12})$/;

/**
 * Transform phone numbers
 * @param string phone 
 * @returns string
 */
 export const phoneTransform = (phone) => {
    return phone
        .replace(/[\s,-]/g,'') // remove spaces and dashes
        .replace(/^0/, '+46') // replace starting 0 with +46
}

export const phoneRemovePlus = (phone) => {
    return phone.replace(/^\+/,'');
}

export const yupName = Yup.string()
    .required('Du måste fylla i ditt namn')

export const yupCity = Yup.string()
    .required('Måste fyllas i')

export const yupEmail = Yup.string()
    .email('Verkar inte vara en epostadress')
    .required('Måste fyllas i')

export const yupPhone = Yup.string()
    .transform( phoneTransform ) 
    .max(20, 'Det är för långt')
    .min(5, 'Är det verkligen hela telefonnumret?')
    .matches(phoneRegExp, 'Telefonnumret är inte giltigt') // match regex
    .required('Du måste fylla i ditt telefonnummer')

